import React, { useState, useRef } from "react";
import { useSelector } from "react-redux";
import VIDEO_SOURCE from "../../assets/videos/How to use GM.mp4";
import PLAY_BTN from "../../assets/images/paly-btn.png";
import { useTranslation } from "react-i18next";

export default function HowToUse() {
  const { t } = useTranslation();
  const [controls, setControls] = useState(false);
  const videoRef = useRef(null);
  const { dir } = useSelector((state) => state.language);

  return (
    <div className="bg-transparent flex flex-column gap-1">
      <p className="how-to-use__title text-white">{t("video.howToUse")}</p>
      <div
        dir={dir}
        className="items__card row mx-0 align-items-md-center px-0 py-0 mt-0 bg-transparent"
        // style={{
        //   backgroundColor: "#1b191f",
        // }}
      >
        <div className="col-12 px-0 bg-transparent">
          <div
            className="items__fig w-100 position-relative"
            style={{
              //   backgroundColor: "#17161b",
              borderRadius: "30px",
              overflow: "hidden",
            }}
          >
            <video
              ref={videoRef}
              src={VIDEO_SOURCE}
              controls={controls}
              loop={true}
              className="w-100 h-100 relative"
              style={{
                display: "block",
                width: "100%",
                height: "100%",
                backgroundColor: "#17161b",
                // objectFit: "cover",
                // aspectRatio: "16/9",
              }}
            >
              <source src={VIDEO_SOURCE} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            {!controls && (
              <button
                onClick={() => {
                  setControls(true);
                  if (videoRef.current) {
                    videoRef.current.play();
                  }
                }}
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  cursor: "pointer",
                  backgroundColor: "white",
                  borderRadius: "50%",
                  width: "50px",
                  height: "50px",
                  zIndex: 10,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img src={PLAY_BTN} alt="How to use" style={{}} />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
